export default "__VITE_ASSET__BaRPkD_3__"